import '../../../app.css';

export default function UnderConstruction() {
	return <div className='panel'>
		<h2>Under Construction</h2>
		<p>This page is currently under construction. Please check back later!</p>
	</div>
}

